import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Field, useFormik, FormikProvider } from "formik";
import React, { useState, useEffect } from "react";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { DashboardServiceReport, lastDayOfMonth, ModuleHeader } from "../../utils/commonFunctions";
import { Form, Table } from "react-bootstrap";

import { store } from "../../../App";
import ShowAlert from "../../alert";
import Swal from "sweetalert2/dist/sweetalert2.js";

const DistrictWiseDateLimit = () => {
    const [apiData, setApiData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]); // Track selected row indices



    const formik = useFormik({
        initialValues: {},
        onSubmit: (values) => {
            const selectedData = selectedRows.map((index) => ({
                dl_jvs: values[`dl_jvs_${index}`],
                code: apiData[index].securitycode,
            }));

            // console.log("Submitted selected rows:", selectedData);
            // console.log("selectedData",selectedData.length);
            if (selectedData.length > 0) {
                Swal.fire({
                    text: "Are you sure you want to submit?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes",
                }).then((result) => {
                    if (!result.isConfirmed) return;
                    store.dispatch({ type: "SHOW_SPINNER" });
                    let params = selectedData;
                    HousingService.updateBudgetControlSystemByDateApi(params)
                        .then((res) => {
                            const { responseToken, responseMsg } = res.data[0];
                            if (responseToken === "1") {
                                ShowAlert(responseMsg, "success").then((isConfirm) => {
                                    if (isConfirm.value) history.go(0);
                                });
                            } else {
                                ShowAlert(responseMsg, "error");
                            }
                        })
                        .catch(() => {
                            ShowAlert("Some error occurred", "error");
                        })
                        .finally(() => {
                            store.dispatch({ type: "HIDE_SPINNER" });
                        });
                });
            }
            else {
                ShowAlert("Please select atleast one checkbox before submitting", "warning");
                return;
            }

        },
    });

    useEffect(() => {
        setSelectedRows([]);
        HousingService.getBudgetControlSystemByDateApi().then((res) => {
            if (res.data) {
                setApiData(res.data);

                const initialFormValues = {};
                res.data.forEach((item, index) => {
                    initialFormValues[`dl_jvs_${index}`] = item.dl_jvs || "";
                });
                formik.setValues(initialFormValues);
            }
        });
    }, []);

    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="District Wise Date Limit" />
            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <DashboardServiceReport title="Report" />
                        <div style={{ textAlign: "center" }}>
                            <h6>Budget Control System(By Date)</h6>
                        </div>
                        <OFMSUI.Row className="mb-3">
                            <Table striped bordered hover fluid>
                                <thead className="fw-bold" style={{ position: "sticky", top: "0px" }}>
                                    <tr className="table_countshead">
                                        <th rowSpan={2} className="text-center">S.No.</th>
                                        <th rowSpan={2} className="text-center">District</th>
                                        <th colSpan={2} className="text-center">JV's</th>
                                        <th rowSpan={2} className="text-center">Select</th>
                                    </tr>
                                    <tr className="table_countshead" style={{ textAlign: "center" }}>
                                        <th>Actual</th>
                                        <th>Present</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {apiData?.length === 0 ? (
                                        <tr style={{ textAlign: "center" }}>
                                            <td colSpan={5}>No data found</td>
                                        </tr>
                                    ) : (
                                        apiData.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-center">{i + 1}</td>
                                                <td>{item.name}</td>
                                                <td className="text-center">25-{lastDayOfMonth}</td>
                                                <td className="text-end">
                                                    <div style={{ width: "100px", marginLeft: "auto" }}>
                                                        <Field
                                                            name={`dl_jvs_${i}`}
                                                            type="number"
                                                            className="form-control text-end"
                                                            min={1}
                                                            max={lastDayOfMonth}
                                                            disabled={selectedRows.includes(i)}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedRows.includes(i)}
                                                        disabled={
                                                            !formik.values[`dl_jvs_${i}`] ||
                                                            Number(formik.values[`dl_jvs_${i}`]) < 1 ||
                                                            Number(formik.values[`dl_jvs_${i}`]) > 31
                                                        }
                                                        onChange={(e) => {
                                                            const isChecked = e.target.checked;
                                                            const dlValue = formik.values[`dl_jvs_${i}`];
                                                            const districtName = item.name;

                                                            if (isChecked) {
                                                                console.log("Selected:", {
                                                                    name: districtName,
                                                                    dl_jvs: dlValue,
                                                                    securitycode: item.securitycode,
                                                                });
                                                                setSelectedRows((prev) =>
                                                                    prev.includes(i) ? prev : [...prev, i]
                                                                );
                                                            } else {
                                                                console.log("Unselected:", {
                                                                    name: districtName,
                                                                    securitycode: item.securitycode,
                                                                });
                                                                setSelectedRows((prev) =>
                                                                    prev.filter((idx) => idx !== i)
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </OFMSUI.Row>
                        <OFMSUI.Row>
                            <center>
                                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                    <button className="btn btn-success" type="submit">
                                        Save
                                    </button>
                                </OFMSUI.Col>
                            </center>
                        </OFMSUI.Row>
                    </Form>
                </FormikProvider>
            </OFMSUI.Container>
        </>
    );
};

export default DistrictWiseDateLimit;
